// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"dbeb5b45","824":"dbeb5b45"}[chunkId] + ".chunk.css";
};